import React, { useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';
import ErrorPageIcon from '@assets/icons/errorPageIcon';

const ErrorPage:React.FC<IProps> = (props) => {

  const renderContainerError = () => {
    return (
      <S.Container>
        <S.SubContainer>
          <S.Title>
            Error 404
          </S.Title>
          <S.Description>
            {props.message ?? `Sorry, we just encountered a technical error. \n\nTry refreshing the page and clearing your cookies and cache. If the problem persists, \nplease create a ticket for our development team to look into the issue`}
          </S.Description>
          <S.IconContainer>
            <ErrorPageIcon />
          </S.IconContainer>
        </S.SubContainer>
      </S.Container>
    )
  }

  return (
    <S.Root>
      {renderContainerError()}
    </S.Root>
  );
}

export default ErrorPage;